/**
 * @file HeaderSection.jsx
 * @author Rishikesh
 * @date 2024-09-11
 * @description Header component of lead-details.
 */
import {
  Breadcrumbs,
  Button,
  Divider,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

export const HeaderSection = ({
  isLoading,
  lead,
  handleCall,
  handleConvertToCandidate,
  handleDelete,
  handleRestore,
}) => {
  const role = useSelector((state) => state.auth.user?.role);
  const isDeleted = Number(lead?.isdeleted) === 1;
  const canManageDelete = role !== "employee" && role !== "agent";

  return (
    <>
      {isLoading ? (
        <Skeleton variant="rounded" width={180} height={24} />
      ) : (
        <Breadcrumbs aria-label="breadcrumb">
          <Link to="/leads">Leads</Link>
          <Typography sx={{ color: "text.primary" }}>Details</Typography>
        </Breadcrumbs>
      )}

      <Stack display="flex" direction="row">
        <Stack flex={1}>
          {isLoading ? (
            <Skeleton
              sx={{ mt: 3 }}
              variant="rounded"
              width={390}
              height={24}
            />
          ) : (
            <Typography
              sx={{ mt: 2 }}
              fontWeight={700}
              fontSize={24}
              color="#222222"
            >
              {lead?.name || "Lead Name"}
            </Typography>
          )}
          {isLoading ? (
            <Skeleton
              sx={{ mt: 1 }}
              variant="rounded"
              width={390}
              height={24}
            />
          ) : (
            <Stack display="flex" mb={0.2} direction="row" spacing={2}>
              <Typography fontSize={14} color="#222222">
                {lead?.email}
              </Typography>
              <Divider orientation="vertical" flexItem />
              <Typography fontSize={14} color="#222222">
                {lead?.personalphone}
              </Typography>
            </Stack>
          )}
        </Stack>
        {isLoading ? (
          <Skeleton
            sx={{ alignSelf: "end", mb: 1 }}
            variant="rounded"
            width={350}
            height={42}
          />
        ) : (
          <Stack
            display="flex"
            spacing={1}
            direction="row"
            alignSelf="end"
            pb={1}
          >
            {!isDeleted && (
              <>
                <Button variant="contained" color="success" onClick={handleCall}>
                  Call
                </Button>
                <Button variant="outlined" onClick={handleConvertToCandidate}>
                  Convert to Candidate
                </Button>
              </>
            )}
            {canManageDelete &&
              (isDeleted ? (
                <Button variant="outlined" onClick={handleRestore}>
                  Restore
                </Button>
              ) : (
                <Button variant="outlined" color="error" onClick={handleDelete}>
                  Delete
                </Button>
              ))}
          </Stack>
        )}
      </Stack>

      {!isLoading && <Divider />}
    </>
  );
};
